/**
 * Created by amirb on 7/26/15.
 */
define(function (require) {
    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var InputField = require("ui/input-field/InputField");
    var ViewController = require('web-agent-framework/ViewController');

    var IdnvViewController = ViewController.extend({
        ControllerName: 'IdnvViewController',
        templateFile : "LP_idnv.html",

        LPViewMap: {
            CONTENT: '.lpview_idnvdropup_content',
            IDNV_SUBMIT_BUTTON: '.lpview_idnv_submit_button',
            IDNV_CLOSE_BUTTON: '.lpview_idnv_close_button',
            DROP_UP_CONTAINER: '.lpview_idnvdropup_content',
            IDNV_BUTTON: '.idnvdropup_button',
            INPUT_TYPE: '.permutation_type_input',
            IDNV_CONTINAR: '.lpview_idnv_changer_dropup',
            IDNV_NUMERIC_INPUT:'.lpview_numeric_input',
            IDNV_QUESTION_CHAR_INPUT:'.permutationMIN',
            IDNV_QUESTION_TYPE_INPUT:'.permutationR',
            IDNV_QUESTION_FIRST_INDEX_INPUT:".lpview_first_char_input",
            IDNV_QUESTION_SECOND_INDEX_INPUT:".lpview_second_char_input"
        },

        initialize: function (constructorData) {
            this.chatId = constructorData.chatId;
            this.visitorId = constructorData.visitorId;
            this.initView();
        },

        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.IDNV_BUTTON, DOMEvent: "click", callback: this.toggleIdnvChangerMenu});
            this.bindViewEvent({selector: this.LPViewMap.IDNV_CONTINAR, DOMEvent: "blur", callback: this.hideIdnvDropUp, ignoreChildBlur: true, includeSelf: true});
            this.bindViewEvent({selector: this.LPViewMap.IDNV_CLOSE_BUTTON, DOMEvent: "click", callback: this.hideIdnvDropUp});
            this.bindViewEvent({selector: this.LPViewMap.IDNV_SUBMIT_BUTTON, DOMEvent: "click", callback: this.submit});
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            this.bindModel({modelPath: participantPath + '.participantState.engagementState', callback: this.handleEngagementStateChanged});
            this.bindModel({modelPath: participantPath + '.chats', callback: this.updateChatId});
        },

        render: function () {

        }
    });

    IdnvViewController.prototype.updateChatId = function(data) {
        var chatId;
        var chatIds = Object.keys(data.newValue);
        for (var chat in chatIds) {
            chatId = chatIds[chat];
            if (chatId && this.chatId !== chatId) {//Split session support
                this.chatId = chatId;
            }
        }
    };

    IdnvViewController.prototype.initView = function () {

        var idnvQuestionView = this.getFirstElement('.idnv_question');
        var title = this.translate("idnv_numeric_input_tooltip");
        var itemsCountText = this.translateObj('idnv_dropup', [
            {
                key: '<span class=\"char_input first_char le\" title='+'\"'+title+'\" tooltip-position=\"top\"></span>',
                args: [
                    {isTranslate: false}
                ]
            },
            {
                key: '<span class=\"char_input second_char le\" title='+'\"'+title+'\" tooltip-position=\"top\"></span>',
                args: [
                    {isTranslate: false}
                ]
            },
            {
                key: '<br>',
                args: [
                    {isTranslate: false}
                ]
            },
            {
                key: '<span class="lpview_idnv_type_input idnv_type_input le"></span>',
                args: [
                    {isTranslate: false}
                ]
            }
        ]);

        idnvQuestionView.innerHTML = itemsCountText;

        this.firstDigit = new InputField({
            model: this.model,
            el:this.getFirstElement('.first_char'),
            permutation :  InputField.Permutation.MIN,
            tabindex: 1,
            autofocus: true,
            inputType: InputField.prototype.InputTypeEnum.numbersBetweenMinToMax,
            range: {min:1,max:99},
            hideErrorMsg: true
        }).render();

        this.secondDigit = new InputField({
            model: this.model,
            inputType: InputField.prototype.InputTypeEnum.numbersBetweenMinToMax,
            el:this.getFirstElement('.second_char'),
            permutation : InputField.Permutation.MIN,
            tabindex: 1,
            range:{min:1,max:99},
            autofocus: false,
            hideErrorMsg: true
        }).render();

        this.typeInput = new InputField({
            model: this.model,
            el:this.getFirstElement('.lpview_idnv_type_input'),
            permutation : InputField.Permutation.R,
            tabindex: 1,
            autofocus: false
        }).render();


        this.firstDigit.listenTo(this.firstDigit, "onfocus", this.firstCharInputFocus.bind(this));
        this.firstDigit.listenTo(this.firstDigit, "change", this.setSubmitButtonState.bind(this));

        this.secondDigit.listenTo(this.secondDigit, "onfocus", this.secondCharInputFocus.bind(this));
        this.secondDigit.listenTo(this.secondDigit, "change", this.setSubmitButtonState.bind(this));

        this.typeInput.listenTo(this.typeInput, "onfocus", this.typeInputFocus.bind(this));
        this.typeInput.listenTo(this.typeInput, "change", this.setSubmitButtonState.bind(this));

        this.visible = false;
        this.lpHide(this.LPViewMap.CONTENT);
        this.clearInputBoxes();
        this.setSubmitButtonState();

    };

    IdnvViewController.prototype.firstCharInputFocus = function(){
        this.unbindOnClickOutside();
        this.bindClickOutSideToInput(this.firstDigit);
    };

    IdnvViewController.prototype.secondCharInputFocus = function(){
        this.unbindOnClickOutside();
        this.bindClickOutSideToInput(this.secondDigit);
    };

    IdnvViewController.prototype.typeInputFocus = function(){
        this.unbindOnClickOutside();
        this.bindClickOutSideToInput(this.typeInput);
    };

    IdnvViewController.prototype.unbindOnClickOutside = function(){
        this.secondDigit.stopListening(this.secondDigit,'onclickoutside');
        this.typeInput.stopListening(this.typeInput,'onclickoutside');
        this.firstDigit.stopListening(this.firstDigit,'onclickoutside');
    };

    IdnvViewController.prototype.handleEngagementStateChanged = function (data) {
        if (data.newValue == 'active') {
            this.lpShow(this.LPViewMap.IDNV_BUTTON);
        } else {
            this.lpHide(this.LPViewMap.IDNV_BUTTON);
            this.lpHide(this.LPViewMap.CONTENT);
        }
    };

    IdnvViewController.prototype.bindClickOutSideToInput = function(marionetteObj){
        if(!marionetteObj){
            return;
        }

        marionetteObj.listenTo(marionetteObj, "onclickoutside", this.onClickOutsideHandler.bind(this));
    };

    IdnvViewController.prototype.getData = function () {
        var returnObj = {};
        returnObj.firstChar = this.firstDigit.getValue();
        returnObj.secondChar = this.secondDigit.getValue();
        returnObj.typeField = this.typeInput.getValue();
        return returnObj;
    };

    IdnvViewController.prototype.isValidForm = function () {
        var formObj = this.getData();
        return formObj.firstChar && formObj.secondChar && formObj.typeField;
    };

    IdnvViewController.prototype.submit = function () {
        var data = this.getData();
        if (!this.isValidForm()) {
            return;
        }
        var messagesText = this.translateObj('idnv_message', [
            parseInt(data.firstChar, 10),
            parseInt(data.secondChar, 10),
            {
                key: data.typeField,
                args: [
                    {isTranslate: true}
                ]
            }]);

        var objToSend = encodeURI(JSON.stringify(data));

        this.modelController.addLine({
            chatId: this.chatId,
            source: 'agent',
            by: this.getModelParam('agent.agentName'),
            textType: "html",
            text: '<span data-lp-collab-type=\"idnv_question\" data-lp-collab-payload=' + objToSend + '>' + messagesText + '</span>',
            time: new Date()
        });
        this.hideIdnvDropUp();
        this.clearInputBoxes();
    };

    IdnvViewController.prototype.toggleIdnvChangerMenu = function (e) {
        if (this.visible) {
            this.hideIdnvDropUp();
        } else {
            this.showIdnvDropUp();
        }
    };

    IdnvViewController.prototype.setSubmitButtonState = function (e) {
        var buttonView = this.getFirstElement(this.LPViewMap.IDNV_SUBMIT_BUTTON);
        var isNotValid = !this.isValidForm();
        if (buttonView) {
            this.isButtonDisabled = isNotValid;
            this.toggleClass(buttonView, 'disabled',isNotValid);
            if (isNotValid) {
                buttonView.setAttribute("title", this.translate('idnv_submit_button_tooltip'));
                buttonView.setAttribute("tooltip-align", "top");
            } else {
                buttonView.removeAttribute("title");
                buttonView.removeAttribute("tooltip-align");
            }
        }
    };

    IdnvViewController.prototype.hideIdnvDropUp = function (e) {
        this.lpHide(this.LPViewMap.CONTENT);
        this.visible = false;
    };

    IdnvViewController.prototype.showIdnvDropUp = function () {
        this.lpShow(this.LPViewMap.CONTENT);
        this.setFocus();
        this.visible = true;
    };

    IdnvViewController.prototype.setFocus = function (e) {
        this.focus(this.LPViewMap.IDNV_CONTINAR);
    };

    IdnvViewController.prototype.onClickOutsideHandler = function(){
        this.setFocus();
        this.unbindOnClickOutside();
    };

    IdnvViewController.prototype.clearInputBoxes = function () {
        this.firstDigit.setValue('');
        this.secondDigit.setValue('');
        this.typeInput.setValue('');
        this.setSubmitButtonState();
    };
  window.IdnvViewController = IdnvViewController;

    return IdnvViewController;
});



